angular.module('bbl.services.simpleshare')

.directive('slideshareBtn', ['simpleSlides', '$parse', '$timeout', function(slideshareService, $parse, $timeout) {

  return {
    restrict: 'EA',
    transclude: true,
    template: '<span>'+
      '<span class="btn-inner" ng-if="!presentation.isUploading" ng-click="uploadSlides()">'+
        '<i class="btn-icon fa fa-slideshare" aria-hidden="true"></i>'+
        '<span class="label">{{presentation.slides?\'Stop Presentation\':\'Presentation\'}}</span>'+
      '</span>'+
      '<span class="btn-inner disabled" ng-if="presentation.isUploading">'+
        '<i class="btn-icon fa {{presentation.progress<100?\'fa-cloud-upload\':\'fa-spinner\'}}" aria-hidden="true"></i>'+
        '<span class="label" ng-if="presentation.progress<100">Uploading {{presentation.progress|number:2}}%</span>'+
        '<span class="label" ng-if="presentation.progress>=100">Processing slides</span>'+
      '</span>'+
    '</span>',

    link: function($scope, $el, atts) {
      var user = $parse(atts.user).bind(0, $scope),
        room = $parse(atts.room)($scope);

      var presentation = slideshareService(user, room);

      $scope.$parent.presentation = {
        progress: 0,
        isUploading: false,
        slides: null,
      };

      function progress(value) {
        $timeout(function() {
          $scope.presentation.progress = value;
        });
      }

      presentation.sub(presentation.types.ONLOAD, function(_, data) {
        $timeout(function() { $scope.presentation.slides = data && data.slides ? data : null; });
      });

      presentation.getPreviousSlides().then(presentation.loadSlideData);

      $scope.uploadSlides = function() {
        if ($scope.presentation.slides) {
          presentation.clearSlideData().then(presentation.loadSlideData.bind(this, {path: '', slides: null}));
          return;
        }

        $('<input type="file" accept=".pptx,.ppt">')
          .one('change', function(ev) {
            var inputfile = ev.target.files[0];
            if (!inputfile) {
              // TODO: throw error, say a file must be selected
              return;
            }

            var ext = inputfile.name.match(/\.[a-z0-9]+$/i);
            var filename = room.replace(/[\/\.]/g, '-')+'-slideshare'+ext;
            var uploadFile = new File([inputfile.slice(0)], filename, {type: inputfile.type});

            $scope.presentation.isUploading = true;
            presentation.upload(uploadFile).then(function() {
              $scope.presentation.isUploading = false;
              progress(0);
            }, function() {
              $scope.presentation.isUploading = false;
              progress(0);
            }, progress);
          }).click();
      };
    }
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/simpleshare/directives/slideshare-btn.js
 ** module id = 227
 ** module chunks = 0
 **/